var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemaleIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 26,
    viewBox: "0 0 13 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0.875C8.28838 0.875 9.6875 2.27412 9.6875 4C9.6875 5.72588 8.28838 7.125 6.5625 7.125C4.83662 7.125 3.4375 5.72588 3.4375 4C3.4375 2.27412 4.83662 0.875 6.5625 0.875ZM12.3869 18.1689L10.0431 8.7939C9.97973 8.54036 9.83341 8.31528 9.62742 8.15445C9.42143 7.99362 9.16759 7.90625 8.90625 7.90625H8.35156C7.24263 8.41616 5.93017 8.43818 4.77344 7.90625H4.21875C3.95741 7.90625 3.70357 7.99362 3.49758 8.15445C3.29159 8.31528 3.14527 8.54036 3.08188 8.7939L0.738133 18.1689C0.553465 18.9075 1.11245 19.625 1.875 19.625H4.60937V24.7031C4.60937 25.3503 5.13403 25.875 5.78125 25.875H7.34375C7.99097 25.875 8.51562 25.3503 8.51562 24.7031V19.625H11.25C12.0113 19.625 12.5718 18.9086 12.3869 18.1689Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcons);
export default __webpack_public_path__ + "static/media/female-icons.4d7df9f9dcb7e042a65ec965492dac07.svg";
export { ForwardRef as ReactComponent };